import { ButtonVariant } from '@ben/orion/deprecated-button';
import { Modal, type ModalProps } from '@ben/orion/modals';
import type { Context, ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmActions {
  confirmAction: (modalProps: ModalProps) => void;
  confirmDelete: (modalProps: ModalProps) => void;
}

const ConfirmActionContext: Context<ConfirmActions> =
  createContext<ConfirmActions>({
    confirmAction: () => undefined,
    confirmDelete: () => undefined,
  });

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState<ModalProps>();

  const contextValue = useMemo((): ConfirmActions => {
    const commonProps: ModalProps = {
      primaryText: t('words.confirm'),
      secondaryText: t('words.cancel'),
    };
    return {
      confirmAction: (modalProps) => {
        setIsOpen(true);
        setModalProps({ ...commonProps, ...modalProps });
      },
      confirmDelete: (modalProps) => {
        setIsOpen(true);
        setModalProps({
          ...commonProps,
          ...modalProps,
          primaryVariant: ButtonVariant.error,
        });
      },
    };
  }, [t]);

  return (
    <ConfirmActionContext.Provider value={contextValue}>
      {children}
      <Modal
        {...modalProps}
        isOpen={isOpen}
        onConfirm={() => {
          setIsOpen(false);
          setTimeout(() => modalProps?.onConfirm?.());
        }}
        onClose={() => {
          setIsOpen(false);
          setTimeout(() => modalProps?.onClose?.());
        }}
      />
    </ConfirmActionContext.Provider>
  );
};

export const useConfirmAction = () => {
  return useContext(ConfirmActionContext);
};
